import { Fragment, useState } from "react"; 
import BannerTable from "./Table";
import "./Banner.css"; 
import Breadcrumb from "../Breadcrumb/Breadcrumb";
 
function Banner() {
  
    return (
        <Fragment>
                        <Breadcrumb title={"مدیریت بنر ها"} />

            <BannerTable />
        </Fragment>
    );
}

export default Banner;
